<div fxFill fxLayoutAlign="space-between start">
  @for (field of rows; track field; let rowIndex = $index) {
    <div [fxFlex]="maxWidth" class="detail-labeled-field">
      <labeled-field [label]="field.Label" [ngClass]="getClass(field)">
        @if (!isAction(field)) {
          @if (!isBoolean(field)) {
            <div class="pre-wrap">
              {{getValue(field)}}
            </div>
          }
          @if (isBoolean(field)) {
            <div fxLayout="row" fxLayoutAlign="center center" class="boolean">
              @if (isTrue(field)) {
                <mat-icon fontIcon="check_circle" class="true">
                </mat-icon>
              }
              @if (!isTrue(field)) {
                <mat-icon fontIcon="do_not_disturb">
                </mat-icon>
              }
              &nbsp;
            </div>
          }
        }
        @if (isAction(field)) {
          <a (click)="performFieldCommand($event, field)" class="link" [attr.aria-label]="getActionAriaLabel(field)" [attr.telemetry]="getActionAriaLabel(field)">
            @if (!isBoolean(field)) {
              <div class="pre-wrap">
                {{getValue(field)}}
              </div>
            }
            @if (isBoolean(field)) {
              <div fxLayout="row" fxLayoutAlign="center center" class="boolean">
                @if (isTrue(field)) {
                  <mat-icon fontIcon="check_circle" class="true">
                  </mat-icon>
                }
                @if (!isTrue(field)) {
                  <mat-icon fontIcon="do_not_disturb">
                  </mat-icon>
                }
                &nbsp;
              </div>
            }
          </a>
        }
      </labeled-field>
    </div>
  }
</div>